import MainComponent from "components/Main";
import ItemPerson from "components/ItemPerson";

import PropTypes from 'prop-types';

export default class ListDoctors extends MainComponent {
    static propTypes = {
        type: PropTypes.string,
        search: PropTypes.string,
        activeId: PropTypes.number,
        customProps: PropTypes.object,
        onClick: PropTypes.func,
        gap: PropTypes.string,
    };

    static defaultProps = {
        type: "doctor",
        search: "",
        activeId: null,
        customProps: {},
        onClick: null,
        gap: "",
    };

    clickItem(id, info) {
        if (this.props.onClick)
            this.props.onClick(id, info);
    }

    customFilter() {
        return true;
    }

    getFiltered(items, search, type) {
        return items.filter(it => {
            if (search) {
                if (!(it.lname + " " + it.fname).toLowerCase().includes(search.toLowerCase()) && !it?.specs?.find(spec => spec?.specEntity?.title?.toLowerCase().includes(search)))
                    return false;
            }

            if (type === "assistent")
                return ((it.roleId === 5 || it.roleId === 6) && it.status !== "FIRED" && it.isActive);

            if (type === "coordinator")
                return ((it.roleId === 12 || it.roleId === 7) && it.status !== "FIRED" && it.isActive);

            if (type === "responsible")
                return (([12, 7, 4, 8, 3]).includes(it.roleId) && it.status !== "FIRED" && it.isActive);

            if (!it.isActive || !it.isDoctor || it.fireDate || !it.specs.length || it.status === "FIRED")
                return false;

            return this.customFilter(it, this.props.customProps);
        });
    }

    checkFilterdItems(items) {
        return items;
    }

    render() {
        const { doctors } = globalThis.appPageView?.state;
        const { gap, search, activeId, type } = this.props;
        const filtered = this.checkFilterdItems(this.getFiltered(doctors, search, type));

        return (
            <div ref={el => this.domNode = el} className={`doctorsList flex col ${gap || "gap8"}`}>
                {filtered.map((it, i) => {
                    return (
                        <ItemPerson
                            key={i}
                            info={it}
                            active={activeId === it.id}
                            onClick={this.clickItem.bind(this, it.id, it)}
                        />
                    );
                })}
            </div>
        );
    }
}
